import {
  GKPRODUCT_PRODUCT_LIST_PARTICULARS_ID_ACTIONS_BEGIN,
  GKPRODUCT_PRODUCT_LIST_PARTICULARS_ID_ACTIONS_SUCCESS,
  GKPRODUCT_PRODUCT_LIST_PARTICULARS_ID_ACTIONS_FAILURE,
  GKPRODUCT_PRODUCT_LIST_PARTICULARS_ID_ACTIONS_DISMISS_ERROR,
} from './constants';
  import request from '../../../utils/request'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function productListParticularsIdActions(params) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: GKPRODUCT_PRODUCT_LIST_PARTICULARS_ID_ACTIONS_BEGIN,
    });

console.log(params)
    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
     request({
       url:`/api/public/gc/product/lng/basic?qpId=${params}`,
       method:'get',
     }).then(
        (res) => {
          dispatch({
            type: GKPRODUCT_PRODUCT_LIST_PARTICULARS_ID_ACTIONS_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: GKPRODUCT_PRODUCT_LIST_PARTICULARS_ID_ACTIONS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissProductListParticularsIdActionsError() {
  return {
    type: GKPRODUCT_PRODUCT_LIST_PARTICULARS_ID_ACTIONS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case GKPRODUCT_PRODUCT_LIST_PARTICULARS_ID_ACTIONS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        productListParticularsIdActionsPending: true,
        productListParticularsIdActionsError: null,
      };

    case GKPRODUCT_PRODUCT_LIST_PARTICULARS_ID_ACTIONS_SUCCESS:
      // The request is success
      return {
        ...state,
        productListParticularsIdActionsPending: false,
        productListParticularsIdActionsError: null,
      };

    case GKPRODUCT_PRODUCT_LIST_PARTICULARS_ID_ACTIONS_FAILURE:
      // The request is failed
      return {
        ...state,
        productListParticularsIdActionsPending: false,
        productListParticularsIdActionsError: action.data.error,
      };

    case GKPRODUCT_PRODUCT_LIST_PARTICULARS_ID_ACTIONS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        productListParticularsIdActionsError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/gkproduct/redux/productListParticularsIdActions.js